module.exports = __webpack_public_path__ + "static/media/image-block.32a48218.svg";